"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section ref={heroRef} className="relative min-h-[600px] lg:min-h-[700px] flex items-center justify-center bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/hero_remodel_project.png)]">
      {}
      <div className="absolute inset-0 bg-dark-background/50" />

      {}
      <div className={`relative z-10 max-w-4xl mx-auto px-4 text-center transition-all duration-[150ms] ease-out ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-foreground mb-4 lg:mb-6">
          Quality Remodeling You Can Trust
        </h1>

        {}
        <p className="text-lg sm:text-xl lg:text-2xl text-foreground max-w-2xl mx-auto mb-8 lg:mb-10">
          Veteran-owned construction experts delivering exceptional results for
          your home
        </p>

        {}
        <Link to="#contact">
          <Button size="lg" className="shadow-medium hover:shadow-strong hover:-translate-y-0.5 transition-all duration-[80ms] ease-in-out px-8 py-6 text-base sm:text-lg">
            Get Your Estimate
          </Button>
        </Link>
      </div>
    </section>;
}